import { findIndex, propEq } from 'ramda'

import { ERROR_SAVE_CAMPAIGN_SERVER } from '@/app/module/campaigns/definitions'
import { capitalizeFirstLetter } from '@/app/module/campaigns/helpers'
import { CampaignItem, Part } from '@/app/module/campaigns/types'
import { getErrorMessage, isErrorResponse } from '@/app/store/api'

export const getCampaignErrorMessage = (error: unknown, item: Pick<CampaignItem, 'variables'>) => {
  const fallbackMessage = getErrorMessage(error, ERROR_SAVE_CAMPAIGN_SERVER)

  if (!isErrorResponse(error)) {
    return fallbackMessage
  }

  if (error.data?.errorCode === 'template.part' && 'parts' in item.variables) {
    const found = findIndex<Part>(propEq('id', error.data.errorContext?.partId), item.variables.parts)
    if (found !== -1) {
      return `${capitalizeFirstLetter(error.data.error)} for the ${found + 1}. message`
    }
    return capitalizeFirstLetter(error.data.error)
  }
  return fallbackMessage
}
